import MaterialTable from "material-table";
import { useEffect } from "react";
import {
    Box,
    Button,
    Select,
    Typography,
    MenuItem,
    Grid,
    CircularProgress,
    IconButton,
    TextField,
    FormControl,
    FormLabel,
    Tooltip,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { getUserData, getUserId, revertDateFormat } from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { AddEmployeeStagetoMainHelper, DeleteEmployeeStageHelper, GetEmployeeStageHelper, UpdateEmployeeStageHelper } from "../../../Finance/helper/BulkUpload/BulkUploadHelper";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { GetEmpIDContractualHelper, GetEmpIDHelper } from "../../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper";
import Note from "../../Image/alert.png";
import EmployeeID from "../../../AdminSettings/views/Employee/EmployeeID";
import Papa from "papaparse";
import Warning from "../../Image/report.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDispatch, useSelector } from "react-redux";
import { GetAccessWorkLocationAction } from "../../../../../store/Ancillary/WorkLocation/Action";
import { GetWorkHoursAction } from "../../../../../store/Leave/WeekOff/Action";
import { GetContractorAction } from "../../../../../store/Ancillary/Contractor/Action";

const EmployeeBulkUpload = ({ onNavigateToImageUpload }) => {
    let userData = getUserData();
    const [, setOpenBulk] = useState(false);
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [show, setShow] = useState(false);
    const [editedRecord, setEditedRecord] = useState(null);
    const [id, setId] = useState();
    const [openPopup, setOpenPopup] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [errors, setErrors] = useState({});
    const [editerrors, setEditErrors] = useState({});
    const [empdata, setEmpData] = useState([]);
    const [stageData, setStageData] = useState([]);
    const [file, setFile] = useState(null);
    const [warning, setWarning] = useState(false);
    const initialColMapping = [
        { excel: "", db: "previous_employee_id", label: "Prev.Emp ID", required: true, tooltip: "Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable." },
        { excel: "", db: "first_name", label: "First Name", required: true },
        { excel: "", db: "last_name", label: "Last Name", required: false },
        { excel: "", db: "ats_work_location_id", label: "Work Location", required: true },
        { excel: "", db: "reportingmanager_id", label: "Reporting Manager", required: true },
        { excel: "", db: "joining_date", label: "Date of Joining", required: true },
        { excel: "", db: "work_hour_configuration_id", label: "Work Hours", required: true },
        { excel: "", db: "contractor", label: "Contractor", required: false, tooltip: "Mapping a contractor will set the employee's Employment Type to Contractual." },
        { excel: "", db: "personal_mobile", label: "Mobile Number", required: false },
        { excel: "", db: "office_email", label: "Email", required: false },
        { excel: "", db: "dob", label: "Date of Birth", required: false },
        { excel: "", db: "_designation_id", label: "Designation", required: false },
        { excel: "", db: "businessUnit", label: "Business Unit", required: false },
        { excel: "", db: "create_user", label: "Create as User", required: false },
    ];
    if (userData?.f_country_code === "IND") {
        initialColMapping.push(
            { excel: "", db: "pan_no", label: "PAN Number", required: false },
            { excel: "", db: "uan_no", label: "UAN Number", required: false }
        );
    }
    const [excelDbColMapping, setExcelDbColMapping] = useState(initialColMapping);
    const [rowHeaders, setRowHeaders] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [empno, setEmpNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [getLoading, setGetLoading] = useState(false);
    const dispatch = useDispatch();
    const { workLocationAccess_options, isLoading } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
    const { contractor_options, isContLoading = isLoading } = useSelector((state) => state?.AtsReducer?.ContractorReducer);
    
    const EmployeeIdConfigCheck = async () => {
        try {
        const [fullTimeRes, contractualRes] = await Promise.all([
            GetEmpIDHelper(),
            GetEmpIDContractualHelper(),
        ]);

        const fullTimeExists = fullTimeRes?.data?.data?.length > 0;
        const contractualExists = contractualRes?.data?.data?.length > 0;

        if (fullTimeExists && contractualExists) {
            setEmpNo({
            fullTime: fullTimeRes.data.data[0],
            contractual: contractualRes.data.data[0],
            });
        } else {
            setEmpNo(null);
        }
        } catch (error) {
        setEmpNo(null);
        }
    };
    useEffect(() => {
        setGetLoading(true);
        GetEmployeeStageHelper().then((res) => {
            setGetLoading(false);
            setEmpData(res?.data?.data?.[0]?.employee_details);
            setStageData(res?.data?.data);
            setId(res?.data?.data?.[0]?.stage_employee_pk)
        });
        dispatch(GetAccessWorkLocationAction());
        dispatch(GetWorkHoursAction());
        dispatch(GetContractorAction());
        EmployeeIdConfigCheck();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectFileClick = () => {
        if (stageData?.length > 0 || empdata?.length > 0) {
            setShowConfirmPopup(true); // Show confirmation popup if data exists
        } else {
            document.getElementById("contained-button-file").click(); // Directly trigger file selection if no data exists
        }
    };
    const fileSelected = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        if (!selectedFile.name.endsWith(".csv")) {
            setShow(true);
            return;
        }
        // processFile(selectedFile, e);
        processCSVFile(selectedFile, e)
    };
    const processCSVFile = (selectedFile, event) => {
        setFile(selectedFile);
        setUploadProgress(0);
        toast.info("Reading CSV File. Please wait...");

        Papa.parse(selectedFile, {
            header: true,
            skipEmptyLines: true,
            beforeFirstChunk: (chunk) => {
                const filteredChunk = chunk
                    ?.split("\n")
                    ?.filter(line => !line?.trim()?.startsWith("#"))
                    ?.join("\n");
                return filteredChunk;
            },
            complete: (result) => {
                const headers = Object.keys(result.data[0]); // Extract CSV headers
                setRowHeaders(headers);
                toast.dismiss();
                toast.success("File imported successfully!");
            },
            error: (error) => {
                toast.error(`Error reading CSV file: ${error.message}`);
            }
        });

        if (event) event.target.value = ""; // Reset the input
    };
    function setColMapping(value, dbCol) {
        setExcelDbColMapping((prev) => {
            prev.forEach((col) => {
                if (col["db"] === dbCol) col.excel = value;
            });
            return [...prev];
        });
    }
    function clearColMapping(dbCol) {
        setExcelDbColMapping((prev) => {
            prev.forEach((col) => {
                if (col["db"] === dbCol) col.excel = "";
            });
            return [...prev];
        });
    }
    const validate = () => {
        const temp = {};
        if (!file) temp.file = "File is required";
        const unmappedRequiredFields = excelDbColMapping.filter(
            (col) => col.required && !col.excel
        );
        if (unmappedRequiredFields.length > 0) {
            toast.error("Please map all required fields.")
            temp.columnMapping = "Please map all required fields.";
        }
        setErrors(temp);
        return Object.keys(temp).length === 0; // Return true if no errors
    };
    async function addEmployeeStage(e) {
        if (empno) {
            if (!validate()) return;
            e.preventDefault();
            try {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("user_id", getUserId());
                formData.append("domain_name", userData?.domain);
                formData.append("column_mapping", JSON.stringify(excelDbColMapping));
                toast.info("Uploading file");
                try {
                    setUploadProgress(0);
                    await axiosInstance
                        .post("/employee/uploadEmployeeFile", formData, {
                            baseURL: HRMS_EMPLOYEE_API_URL,
                            headers: {
                                Accept: "multipart/form-data",
                                "Content-Type": "multipart/form-data",
                            },
                            onUploadProgress: (progress) => {
                                const percentCompleted = Math.round(
                                    (progress.loaded * 90) / progress.total
                                );
                                setUploadProgress(percentCompleted);
                                if (percentCompleted > 89) {
                                    toast.dismiss();
                                    toast.info("Uploading...");
                                }
                            },
                        })
                        .then((response) => {
                            const result = response?.data?.statuscode;
                            setEmpData(response?.data?.data?.[0]?.employee_details)
                            setStageData(response?.data?.data);
                            setId(response?.data?.data?.[0]?.stage_employee_pk)
                            if (result) {
                                toast.dismiss();
                                toast.success("File uploaded successfully!");
                            }
                        });

                    setUploadProgress(100);
                    setFile(null);
                    // refreshCatalog();
                } catch (error) {
                    setUploadProgress(0);
                    toast.warning(error.response?.data?.message || error.message);
                }
            } catch (error) {
                console.error("Unexpected error", error);
            }
        }
        else {
            setWarning(true);
        }
    }
    async function handleSubmit(e) {
        AddEmployeeStagetoMainHelper().then((res) => {
            if (res.data.statuscode === 200) {
                const resMessage = res?.data?.data?.[0]?.["fn_upsert_imported_employee_data"];
                toast.dismiss();
                toast.success("File processed successfully!");
                if (resMessage?.split(" ")[0] > 0) {
                    toast.warn(`Employee bulk upload failed for ${resMessage?.split(" ")[0]} record(s): Previous Employee ID is missing.`);
                }
                setEmpData([]);
                setStageData([]);
                // if (onNavigateToImageUpload) {
                //     onNavigateToImageUpload();
                // }
            } else {
                toast.error("The bulk upload failed. Please try again");
            }
        });
    }

    const handleNavigate = (menu, value) => {
        setOpenConfirmation(true);
        setWarning(false);
    };
    const [loader, setLoader] = useState(false);
    const handleCancel = () => {
        setLoader(true);
        DeleteEmployeeStageHelper({ stage_employee_id: stageData?.length > 0 ? null : id }).then((res) => {
            setLoader(false);
            setShowConfirmPopup(false);
            if (res.data.statuscode === 200) {
                setStageData([]);
                setEmpData([]); // Clear table data
                setFile(null); // Allow new file selection
                document.getElementById("contained-button-file").click();
            } else {
                toast.error("Something went wrong")
            }
        });
    };
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };
    const handleConfirmDelete = (rowData) => {
        setOpenDialog(true);
        setCurrentData(rowData)
    };
    const handleDelete = () => {
        const updatedData = empdata?.filter(emp => emp?.previous_employee_id !== currentData?.previous_employee_id); // Use unique field
        setEmpData(updatedData); // Update state
        toast.success("Record deleted successfully!");
        setOpenDialog(false);
        UpdateEmployeeStageHelper({ stage_employee_id: id, employee_details: JSON.stringify(updatedData) }).then((res) => {
        });
    };
    const handleEditSubmit = (updatedRecord) => {
        if (!validateFields()) return;
        const updatedData = empdata?.map(emp =>
            emp?.tableData?.id === updatedRecord?.tableData?.id ? updatedRecord : emp // Replace edited record
        );
        setEmpData(updatedData); // Update state
        UpdateEmployeeStageHelper({ stage_employee_id: id, employee_details: JSON.stringify(updatedData) }).then((res) => {
        });
        setOpenPopup(false); // Close popup
        toast.success("Record updated successfully!");
    };
    const validateFields = () => {
        const tempErrors = {};
        const mobileRegex = /^\d{10}$/;
        if (!editedRecord?.previous_employee_id) tempErrors.previous_employee_id = "Prev.Emp ID is required.";
        if (!editedRecord?.first_name) tempErrors.first_name = "First Name is required.";
        if (!editedRecord?.ats_work_location_id) tempErrors.ats_work_location_id = "Work Location is required.";
        if (!editedRecord?.reportingmanager_id) tempErrors.reportingmanager_id = "Reporting Manager is required.";
        if (!editedRecord?.joining_date) tempErrors.joining_date = "Date of Joining is required.";
        if (!editedRecord?.work_hour_configuration_id) tempErrors.work_hour_configuration_id = "WorkHour is required.";
        if (!editedRecord?.personal_mobile) {
            tempErrors.personal_mobile = "Mobile number is required.";
        } else if (!mobileRegex.test(editedRecord.personal_mobile)) {
            tempErrors.personal_mobile = "Enter a valid 10-digit number.";
        }
        setEditErrors(tempErrors);
        return Object.keys(tempErrors).length === 0; // Return true if no errors
    };
    const sampleData = [
        [
        "Prev.Emp ID",
        "First Name",
        "Last Name",
        "Mobile Number",
        "Email",
        "Date of Birth",
        "Designation",
        "Work Location",
        "Reporting Manager",
        "Contractor",
        "Date of Joining",
        "Business Unit",
        "PAN Number",
        "UAN Number",
        "Work Hours",
        "Create as User"
    ],
    [
        "EMP00123",
        "John",
        "Doe",
        "9876543210",
        "john.doe@example.com",
        "15-05-1990",
        "Software Engineer",
        `${workLocationAccess_options?.length ? workLocationAccess_options?.[0]?.work_location_name : "New York"}`,
        "Jane Smith",
        `${contractor_options?.length ? contractor_options?.[0]?.name : "Contractor Name"}`,
        "01-06-2023",
        "IT Services",
        "ABCDE1234F",
        "123456789012",
        `${work_hours_data?.length ? work_hours_data?.[0]?.work_hour_code : "WH9"}`,
        "Yes"
    ],
    ];
    const commonGuides = [
        "Prev.Emp ID: Reference ID / Employee ID from the legacy system / Org ID / Biometric ID as applicable.",
        `Work Hours Code is WH9 : Enter 9  #Configured Work Hours Codes: [${work_hours_data?.length ? work_hours_data?.map(loc => loc.work_hour_code).join(" / ") : "N/A"}]`,
        "Dates : dd-mm-yyyy format (e.g. 01-01-2025)",
        `Configured Locations: [${workLocationAccess_options?.length ? workLocationAccess_options?.map(loc => loc?.work_location_name).join(" / ") : "N/A"}]`,
        `Configured Contractors: [${contractor_options?.length ? contractor_options?.map(loc => loc?.name).join(" / ") : "N/A"}]`,
        "Mobile Number: Enter employee\'s mobile number (used for official communication).",
        "Do Not remove these lines starting with '#' (they are for guidance only)"
    ];
    const handleDownload = () => {
            const ws = XLSX.utils.aoa_to_sheet(sampleData);
            let csv = XLSX.utils.sheet_to_csv(ws);
            const allGuides = [ `Employee Bulk Guide (Input Format)`,
                ...commonGuides];
            if (allGuides?.length > 0) {
                const guideText = allGuides?.map(line => `########## ${line} ##########`)?.join("\n") + "\n####\n####\n";
                csv = guideText + csv;
            }
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Sample_Employee.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
        };
    return (
        <>
            <Popup
                maxWidth="xs"
                openPopup={show}
                setOpenPopup={setShow}
                close={false}
                hideDividers={true}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                    }}
                >
                    <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
                        <img src={Warning} alt="UnSupport File" width={"25%"} />
                    </Box>
                    <FormControl>
                        <FormLabel id="gender-label">
                            <Typography variant="h5" className="blink">
                                Invalid File Type, Accepted file type is .csv
                            </Typography>
                        </FormLabel>
                    </FormControl>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            paddingTop: "10px",
                        }}
                    >
                        <Button
                            onClick={() => {
                                setShow(false);
                            }}
                            variant="contained"
                            type="submit"
                            className="mpl-primary-btn profile-btn"
                            size="small"
                            sx={{
                                margin: "10px",
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Popup>
                <>
                    <Box sx={{ maxHeight: "calc(100vh - 75px)", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                        
                        <Box sx={{ pt: 1, pb: 1 }}>
                            <form
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "9px",
                                }}
                            >
                                <Box
                                    sx={{
                                        padding: "5px",
                                        borderRadius: "8px",
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #dce3ea",
                                        cursor: (isLoading || isContLoading) ? "not-allowed" : "pointer",
                                        opacity: (isLoading || isContLoading) ? 0.6 : 1,
                                        transition: "all 0.2s ease-in-out",
                                        pointerEvents: (isLoading || isContLoading) ? "none" : "auto",
                                        "&:hover": {
                                            backgroundColor: (isLoading || isContLoading) ? "#ffffff" : "#e8f5e9",
                                        },
                                    }}
                                    onClick={!(isLoading || isContLoading) ? handleDownload : undefined}
                                >
                                    <Typography variant="body1" sx={{ fontWeight: 500, color: "#1976d2",display: "flex",
                                        alignItems: "center",
                                        gap: "8px", }}>
                                        <Box
                                            component="span"
                                            sx={{
                                                display: "inline-block",
                                                fontSize: "20px",
                                                animation: (isLoading || isContLoading) ? "spin 1s linear infinite" : "none",
                                                "@keyframes spin": {
                                                "0%": { transform: "rotate(0deg)" },
                                                "100%": { transform: "rotate(360deg)" },
                                                },
                                            }}
                                            >
                                            📄
                                        </Box> 
                                        Download Sample CSV Template
                                    </Typography>
                                </Box>
                                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        {file ? (
                                            <p style={{ margin: 0 }}>{file.name.substring(0, 20)}...</p>
                                        ) : errors?.selectedFile ? (
                                            <p style={{ color: "red", margin: 0 }}>No file chosen</p>
                                        ) : (
                                            <p style={{ margin: 0 }}>No file chosen</p>
                                        )}
                                    </div>
                                    <label htmlFor="contained-button-file" style={{ display: "none" }}>
                                        <input
                                            accept=".csv"
                                            id="contained-button-file"
                                            type="file"
                                            style={{ display: "none" }}
                                            multiple={false}
                                            onChange={fileSelected}
                                        />
                                    </label>
                                    <Button
                                        variant="contained"
                                        className="mpl-primary-btn"
                                        component="span"
                                        sx={{ marginBottom: "5px" }}
                                        onClick={handleSelectFileClick}
                                        disabled={getLoading}
                                    >
                                        { getLoading ? <CircularProgress size={24} disableShrink/> : "Select File"}  
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className="mpl-primary-btn"
                                        sx={{ marginBottom: "5px", marginRight: "5px" }}
                                        disabled={!empdata || empdata?.length === 0}
                                        onClick={handleSubmit}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </form>
                        </Box>

                        <MaterialTable
                            isLoading={getLoading}
                            columns={[
                                {
                                    title: "Prev.Emp ID",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "previous_employee_id",
                                    grouping: false,
                                },
                                {
                                    title: "First Name",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "first_name",
                                    grouping: false,
                                },
                                {
                                    title: "Last Name",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "last_name",
                                    grouping: false,
                                },
                                {
                                    title: "Email",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "office_email",
                                    grouping: false,
                                },
                                {
                                    title: "D.O.J",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "joining_date",
                                    render: rowData  => revertDateFormat(rowData?.joining_date)
                                },
                                {
                                    title: "Work Hours",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "work_hour_configuration_id",
                                },
                                {
                                    title: "Work Location",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "ats_work_location_id",
                                },
                                {
                                    title: "R.Manager",
                                    cellStyle: { padding: "10px 10px 10px 13px" },
                                    field: "reportingmanager_id",
                                },
                            ]}
                            data={empdata}
                            options={{
                                maxBodyHeight: "calc(100vh - 255px)",
                                minBodyHeight: "calc(100vh - 255px)",
                                rowStyle: { fontSize: "13px" },
                                headerStyle: { padding: "10px 10px 10px 13px", fontWeight: "bold", position: "sticky", top: 0 },
                                sorting: true,
                                search: true,
                                searchText: "",
                                searchFieldAlignment: "right",
                                searchAutoFocus: true,
                                searchFieldVariant: "standard",
                                filtering: false,
                                paging: true,
                                pageSizeOptions: [25, 50],
                                pageSize: 25,
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                paginationPosition: "bottom",
                                exportButton: false,
                                exportAllData: false,
                                exportFileName: "Employees",
                                addRowPosition: "first",
                                selection: false,
                                actionsColumnIndex: -1,
                                showSelectAllCheckbox: true,
                                showTextRowsSelected: true,
                                grouping: false,
                                columnsButton: false,
                                toolbar: true,
                            }}

                            actions={[
                                {
                                    icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                    tooltip: "Edit",
                                    onClick: (_event, rowData) => { handleEdit(rowData) },
                                },
                                {
                                    icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                                    tooltip: "Delete",
                                    onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                                },
                            ]}
                            title="Employee Bulk Upload"
                        />
                        <Popup
                            maxWidth="sm"
                            fullWidth={true}
                            title="Pls map the column headers from your sheet & Meepl Fields"
                            openPopup={file}
                            close={false}
                            setOpenPopup={setOpenBulk}
                        >
                            <Box>
                                <Box
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        alignItems: "center",
                                        padding: 5,
                                        borderBottom: "1px solid gray",
                                    }}
                                >
                                    <Typography variant="h6" style={{ textAlign: "center" }}>
                                        Imported Headers
                                    </Typography>
                                    <Typography variant="h6" style={{ textAlign: "center" }}>
                                        Meepl Fields
                                    </Typography>
                                </Box>
                                {excelDbColMapping.map((col) => (
                                    <Grid
                                        key={col.db}
                                        container
                                        spacing={2}
                                        style={{
                                            padding: 5,
                                            alignItems: "center",
                                        }}
                                    >
                                        <Grid sx={{ mt: 2 }} item xs={6} container alignItems="center" spacing={1}>
                                            <Grid item xs>
                                                <Select
                                                    onChange={(e) => setColMapping(e.target.value, col.db)}
                                                    value={col.excel}
                                                    fullWidth
                                                    required={col.required}
                                                    variant="standard"
                                                >
                                                    {rowHeaders.map((header) => (
                                                        <MenuItem key={header} value={header}>
                                                            {header}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                            {col.excel && (
                                                <Grid item>
                                                    <IconButton onClick={() => clearColMapping(col.db)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid sx={{ mt: 2 }} item xs={6}>
                                            <Typography>
                                                {col.label || col.db}
                                                {col.required && " *"}
                                                { col?.tooltip && <Tooltip title={col?.tooltip} arrow>
                                                    <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer", marginLeft: "5px" }} />
                                                </Tooltip> }
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Box>

                            <Box sx={{ display: "flex", justifyContent: "space-between", m: 2 }}>
                                <Button
                                    onClick={() => {
                                        setFile(null);
                                        setRowHeaders([]);
                                        setOpenBulk(false);
                                    }}
                                    className="mpl-primary-btn"
                                    disabled={uploadProgress > 0 && uploadProgress < 100}
                                >
                                    Close
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    className="mpl-primary-btn"
                                    onClick={addEmployeeStage}
                                    disabled={uploadProgress > 0 && uploadProgress < 100}
                                    startIcon={(uploadProgress > 0 && uploadProgress < 100) ? <CircularProgress size={18} color="inherit" /> : null}
                                >
                                    Upload
                                </Button>
                            </Box>
                        </Popup>
                        <Popup
                            maxWidth="xs"
                            fullWidth={true}
                            title="Attention Needed!"
                            openPopup={showConfirmPopup}
                            close={false}
                            setOpenPopup={setShowConfirmPopup}
                        >
                            <Typography variant="h5"> You will lose the imported data. Do you want to submit it before proceeding? </Typography>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                                <Button
                                    onClick={handleCancel}
                                    className="mpl-primary-btn"
                                    disabled={loader}
                                    startIcon={loader ? <CircularProgress size={18} color="inherit" /> : null}
                                >
                                    No
                                </Button>

                                <Button
                                    onClick={() => {
                                        setShowConfirmPopup(false); // Close popup and retain existing data
                                    }}
                                    className="mpl-primary-btn"
                                >
                                    Yes
                                </Button>

                            </Box>
                        </Popup>
                        <Popup
                            title={"Edit Employee"}
                            openPopup={openPopup}
                            setOpenPopup={setOpenPopup}
                        >
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                handleEditSubmit(editedRecord); // Call edit submit with updated record
                            }}>
                                <TextField
                                    size="small"
                                    label="Previous Employee ID"
                                    value={editedRecord?.previous_employee_id || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, previous_employee_id: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                    required
                                    {...(editerrors.previous_employee_id && {
                                        error: true,
                                        helperText: editerrors.previous_employee_id,
                                    })}
                                />
                                <TextField
                                    size="small"
                                    label="First Name"
                                    value={editedRecord?.first_name || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, first_name: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                    required
                                    {...(editerrors.first_name && {
                                        error: true,
                                        helperText: editerrors.first_name,
                                    })}
                                />
                                <TextField
                                    size="small"
                                    label="Last Name"
                                    value={editedRecord?.last_name || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, last_name: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                />

                                <TextField
                                    size="small"
                                    label="Work Location"
                                    value={editedRecord?.ats_work_location_id || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, ats_work_location_id: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                    required
                                    {...(editerrors.ats_work_location_id && {
                                        error: true,
                                        helperText: editerrors.ats_work_location_id,
                                    })}
                                />
                                <TextField
                                    size="small"
                                    label="Reporting Manager"
                                    value={editedRecord?.reportingmanager_id || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, reportingmanager_id: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                    required
                                    {...(editerrors.reportingmanager_id && {
                                        error: true,
                                        helperText: editerrors.reportingmanager_id,
                                    })}
                                />
                                <FormControl fullWidth sx={{ mb: 3 }}>
                                    <CommonDatePicker
                                        required
                                        size="small"
                                        name="joining_date"
                                        label="Date of Joining"
                                        pickerType="date"
                                        onKeyPress={(e) => e.preventDefault()}
                                        onKeyDown={(e) => e.preventDefault()}
                                        pickerFormat="dd/MM/yyyy"
                                        DefaultDTvalue={editedRecord?.joining_date}
                                        handleChange={(value) =>
                                            setEditedRecord({
                                                ...editedRecord,
                                                joining_date: value
                                                    ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                                                    : "",
                                            })
                                        }
                                        {...(editerrors.joining_date && {
                                            error: true,
                                            helperText: editedRecord.joining_date,
                                        })}
                                    />
                                </FormControl>
                                <TextField
                                    size="small"
                                    label="Work Hours"
                                    value={editedRecord?.work_hour_configuration_id || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, work_hour_configuration_id: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                    required
                                    {...(editerrors.work_hour_configuration_id && {
                                        error: true,
                                        helperText: editerrors.work_hour_configuration_id,
                                    })}
                                />
                                <TextField
                                    size="small"
                                    label="Mobile Number"
                                    value={editedRecord?.personal_mobile || ""}
                                    required
                                    type="number"
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");
                                        if (value.length <= 10) {
                                            setEditedRecord({
                                                ...editedRecord,
                                                personal_mobile: value,
                                            });
                                        }
                                    }}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                    {...(editerrors.personal_mobile && {
                                        error: true,
                                        helperText: editerrors.personal_mobile,
                                    })}
                                />
                                <TextField
                                    size="small"
                                    label="Email"
                                    value={editedRecord?.office_email || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, office_email: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                />
                                <FormControl fullWidth sx={{ mb: 3 }}>
                                    <CommonDatePicker
                                        size="small"
                                        name="dob"
                                        label="Date of Birth"
                                        pickerType="date"
                                        onKeyPress={(e) => e.preventDefault()}
                                        onKeyDown={(e) => e.preventDefault()}
                                        maxDate={new Date().setFullYear(
                                            new Date().getFullYear() - 18
                                        )}
                                        pickerFormat="dd/MM/yyyy"
                                        DefaultDTvalue={editedRecord?.dob}
                                        handleChange={(value) =>
                                            setEditedRecord({
                                                ...editedRecord,
                                                dob: value
                                                    ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                                                    : "",
                                            })
                                        }
                                        sx={{ mb: 3 }}
                                    />
                                </FormControl>
                                <TextField
                                    size="small"
                                    label="Designation"
                                    value={editedRecord?._designation_id || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, _designation_id: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                />
                                <TextField
                                    size="small"
                                    label="Business Unit"
                                    value={editedRecord?.businessUnit || ""}
                                    onChange={(e) => setEditedRecord({ ...editedRecord, businessUnit: e.target.value })}
                                    fullWidth
                                    sx={{ mb: 3 }}
                                />
                                {userData?.f_country_code === "IND" && (
                                    <TextField
                                        size="small"
                                        label="PAN Number"
                                        value={editedRecord?.pan_no || ""}
                                        onChange={(e) => setEditedRecord({ ...editedRecord, pan_no: e.target.value })}
                                        fullWidth
                                        sx={{ mb: 3 }}
                                    />
                                )}
                                {userData?.f_country_code === "IND" && (
                                    <TextField
                                        size="small"
                                        label="UAN Number"
                                        value={editedRecord?.uan_no || ""}
                                        onChange={(e) => setEditedRecord({ ...editedRecord, uan_no: e.target.value })}
                                        fullWidth
                                        sx={{ mb: 3 }}
                                    />
                                )}
                                <FormControlLabel
                                    label={"Create as User"}
                                    control={
                                    <Checkbox
                                        checked={!!editedRecord?.create_user}
                                        onChange={(e) => {
                                        setEditedRecord((prev) => ({
                                            ...prev,
                                            create_user: e.target.checked,
                                        }));
                                        }}
                                    />
                                    }
                                />

                                {/* Add other fields similarly */}
                                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                                    <Button onClick={() => setOpenPopup(false)} className="mpl-primary-btn">Cancel</Button>
                                    <Button type="submit" variant="contained" className="mpl-primary-btn">
                                        Save
                                    </Button>
                                </Box>
                            </form>
                        </Popup>
                        <ConfirmationDialog
                            title="Do you wish to proceed?"
                            openDialog={openDialog}
                            closeDialog={setOpenDialog}
                            OkButtonText="Delete"
                            onSubmit={handleDelete}
                        />
                        <Popup
                            title={"Employee ID Configuration"}
                            openPopup={openConfirmation}
                            setOpenPopup={setOpenConfirmation}
                            maxWidth="md"
                            fullWidth={true}
                        >
                            <EmployeeID validateOnly={true} setOpenConfirmation={() => {setOpenConfirmation(false); EmployeeIdConfigCheck();}} />
                        </Popup>
                        <Popup
                            maxWidth="sm"
                            openPopup={warning}
                            setOpenPopup={setWarning}
                            title="Note!"
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
                                    <img src={Note} width={"25%"} alt="note_img" />
                                </Box>
                                <FormControl>
                                    <FormLabel id="gender-label">
                                        <Typography variant="h5">
                                            Employee No Configuration is incomplete. Please navigate to Settings &gt; General  &gt; Organization &gt; Employee ID Configuration
                                        </Typography>
                                    </FormLabel>
                                </FormControl>

                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    paddingTop: "10px",
                                }}
                            >
                                <Button
                                    onClick={() => handleNavigate("General", "4")}
                                    variant="contained"
                                    type="submit"
                                    className="mpl-primary-btn profile-btn"
                                    size="small"
                                    sx={{
                                        margin: "10px",
                                    }}
                                >
                                    Click Here
                                </Button>
                            </Box>
                        </Popup>
                    </Box>
                </>
        </>
    );
};

export default EmployeeBulkUpload;